import React from 'react';

const FormErrorMessage = ({ error, messages }) => {
  if (!error) {
    return null;
  }

  const errorMessage =
    error.type && messages[error.type] ? messages[error.type] : error || 'Error in field';

  return (
    <span className='text-danger !font-[500] !text-[14px] !text-Primary_Regular fs-13 text-[#B41E45]'>
      {errorMessage}
    </span>
  );
};

export default FormErrorMessage;
